import {useMutation} from '@tanstack/react-query';
import {LoginApi} from '../../../apis/LoginApi/LoginApi.ts';
import {CurrentUser} from '../CurrentUser.ts';
import { ISignInChallenge, isSignInChallenge } from '../SignInChallenge.ts';
import { rememberSignedInUser } from '../rememberSignedInUser.ts';

export function usePostLoginMutation() {

    return useMutation<CurrentUser | ISignInChallenge, Error, { username: string; password: string }>({
        mutationFn: async ({username, password}) => {
            const result = await LoginApi.login({username, password});
            if (!result) 
                throw new Error('Invalid credentials');
            
            return isSignInChallenge(result) ? result : new CurrentUser(result);
        },
        onSuccess: (answer) => {
            if (!isSignInChallenge(answer))
                rememberSignedInUser(answer);
        },
        onError: (error) => {
            console.error('Login failed:', error.message);
        },
    });
}
